/* eslint-disable */
import { auth } from '@/plugins/auth/firebase.js'
import Cookie from 'js-cookie'
import JWTDecode from 'jwt-decode'
import Papa from "papaparse";
import Vue from 'vue'
import QRious from 'qrious'

export const products = {
  namespaced: true,
  state: {
    q: '',
    product_list: null,
    currentItem: {},
    isLoading: false,
    transactions: [],
    currentType: 'sales',
    shop: null,
  },

  mutations: {

    SET_CURRENT_TYPE (state, payload) {
      state.currentType = payload
    },
    SET_PRODUCT_LIST (state, payload) {
      state.product_list = payload
    },
    SET_LOADING (state, payload) {
      state.isLoading = payload
    },
    SET_CURRENT_ITEM (state, payload) {
      state.currentItem = payload
    },
    SET_TRANSACTION_LOG (state, payload) {
      // console.log(payload)
      state.transactions = payload
    },
    SET_QUERY (state, payload) {
      state.q = payload
    },
    SET_SHOP (state, payload) {
      state.shop = payload
    },
  },

  actions: {
    setShop ({ commit, state, rootState }, payload) {
      commit('SET_SHOP', payload)
    },
    setQuery ({ commit, state, rootState }, payload) {
      commit('SET_QUERY', payload)
    },
    loadProductLog ({ commit, state, rootState }, payload) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        let userId = ''
        if(rootState.users.user.adminUid){
          userId = rootState.users.user.adminUid
        }else{
          userId = rootState.users.user.uid
        }
        let path
        let loadCommit
        const type = payload[0]
        const from = payload[1]
        const to = payload[2]

        path = `users/${userId}/transactions/${type}`
        const fireDB = firebase.database().ref().child(path)
        loadCommit = 'SET_TRANSACTION_LOG'
        let fireRef
        // console.log(from, to)
        if (from && to) {
          fireRef = fireDB.orderByChild('time').startAt(from).endAt(to)
        } else if (!from || !to) {
          fireRef = from ? fireDB.orderByChild('time').startAt(from) : to ? fireDB.orderByChild('time').endAt(to) : fireDB
        }
        fireRef.once('value',
          function (data) {
            const items = []
            const itemList = data.val() || {}
            Object.keys(itemList).forEach(function (key) {
              items.push({
                ...itemList[key],
              })
            })
            commit('SET_LOADING', false)
            commit(loadCommit, items)

            commit('SET_CURRENT_TYPE', type)
            resolve()
          }, function (error) {
            commit('SET_LOADING', false)
            console.error(error)
            reject()
          },
        )
      })
    },
    exportProductRecord ({ commit, state, rootState }, payload) {
      return new Promise(async (resolve, reject) => {
        let userId = ''
        if(rootState.users.user.adminUid){
          userId = rootState.users.user.adminUid
        }else{
          userId = rootState.users.user.uid
        }
        let path
        const from = payload[0]
        const to = payload[1]
        const totals = payload[2]
        let csv = []
        csv.push([state.currentItem.name])
        csv.push(['desde: ' + Vue.moment(from).format("YYYY-MM-DD")])
        if (Vue.moment(to).isBefore(Date.now())) {
          csv.push(['hasta: ' + Vue.moment(to).format("YYYY-MM-DD")])
        } else {
          csv.push(['hasta: ' + Vue.moment(Date.now()).format("YYYY-MM-DD")])
        }
        csv.push(['ventas: ' + totals[0]])
        csv.push(['compras: ' + totals[1]])
        csv.push(['ordenes: ' + totals[2]])
        const transactions = ['sales','purchases','transfers']
        for (const t of transactions) {
          path = `users/${userId}/transactions/${t}`
          if (t === 'sales') {
            csv.push(['ventas'])
            csv.push(['Referencia', 'Fecha', 'Lugar', 'Cantidad', 'Precio de compra', 'Precio de venta', 'Utilidad', 'Total'])
          } else if (t === 'purchases') {
            csv.push(['compras'])
            csv.push(['Referencia', 'Fecha', 'Lugar', 'Cantidad', 'Precio de compra', 'Total'])
          } else if (t === 'transfers') {
            csv.push(['traslados'])
            csv.push(['Referencia', 'Fecha', 'desde', 'hacia', 'Cantidad'])
          }
          const fireDB = firebase.database().ref().child(path)
          let fireRef
          if (from && to) {
            fireRef = fireDB.orderByChild('time').startAt(from).endAt(to)
          } else if (!from || !to) {
            fireRef = from ? fireDB.orderByChild('time').startAt(from) : to ? fireDB.orderByChild('time').endAt(to) : fireDB
          }
          await fireRef.once('value').then((data) => {
              const itemList = data.val() || {}
              Object.keys(itemList).forEach(function (key) {
                let csvRow = []
                const item = itemList[key]
                item.items.forEach(el => {
                  if (el.name.includes(state.currentItem.name)) {
                    csvRow.push(item.reference_number)                
                    csvRow.push(Vue.moment(item.time).format("h:mm:ss a, dddd, MMMM Do YYYY"))
                    if (t === 'purchases') {
                      csvRow.push(item.location_to.name)
                    } else {
                      csvRow.push(item.location_from.name)
                    }
                    if (t === 'transfers') {
                      csvRow.push(item.location_to.name)
                    }
                    csvRow.push(+el.amount)
                    if (t === 'sales') {
                      csvRow.push(+el.purchase)
                    }
                    if (t !== 'transfers'){
                      csvRow.push(+el.price)
                    }
                    if (t === 'sales') {
                      const utility = (+el.pricewithouttax - +el.purchase) * 100 / +el.pricewithouttax
                      csvRow.push(utility.toFixed(2))
                    }
                    if (t !== 'transfers') {
                      csvRow.push(+el.price * el.amount | 0)
                    }
                  }
                })
                csv.push(csvRow)
              })
            }, function (error) {
              console.error(error)
              reject()
            },
          )
        }
        var blob = new Blob([Papa.unparse(csv,{skipEmptyLines: 'greedy',delimiter: ";"})], { type: 'text/csv;charset=utf-8;' })
        var link = document.createElement("a")
        var url = URL.createObjectURL(blob)
        link.setAttribute("href", url)
        link.setAttribute("download", state.currentItem.name + '_' + from + '_' + Vue.moment(Date.now()).format("YYYY-MM-DD") + '.csv')
        link.style.visibility = 'hidden'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        resolve()
      })
    },
    loadItems ({ commit, state, rootState, dispatch }, type) {
      return new Promise((resolve, reject) => {
        commit('SET_LOADING', true)
        let userId = ''
        if(rootState.users.user.adminUid){
          userId = rootState.users.user.adminUid
        }else{
          userId = rootState.users.user.uid
        }
        // console.log(userId)
        let path
        let loadCommit
        switch (type) {
          case 'inventory':
            path = `users/${userId}/inventory`
            loadCommit = 'SET_PRODUCT_LIST'
            break
        }

        firebase.database().ref(path).orderByChild('name').on('value',
          function (data) {
            let items = []
            if (data.val()) {
              items = Object.values(data.val()) || [];
            }
            commit(loadCommit, items)
            commit('SET_LOADING', false)
            resolve()
          }, function (error) {
            dispatch('users/showErrorSessionExpired', null, {root:true})
            // console.log(error)
            commit('SET_LOADING', false)
            reject()
          },
        )
      })
    },
    async setCurrentItem ({dispatch, commit, state, rootState }, payload) {
      // commit('SET_LOADING', true);
      let userId = ''
      if(rootState.users.user.adminUid){
        userId = rootState.users.user.adminUid
      }else{
        userId = rootState.users.user.uid
      }
      // console.log(userId)
      // console.log(payload)

      if (payload) {
        const path = `users/${userId}/inventory`
        const setCommit = 'SET_CURRENT_ITEM'
        let id = payload.id || null
        // console.log(payload, state.product_list)
        if (!!state.product_list) {
          const currentItem = state.product_list.find(item => item.id === payload.id)
          // console.log(currentItem)
          if (currentItem) {
            // console.log(currentItem)
            commit(setCommit, currentItem)
          } else {
            const dbRef = firebase.database().ref()
            let item
            // console.log(path + '/' + id)
            await dbRef.child(path + '/' + id).on('value', function (data) {
              // console.log(data.val(), id)
              item = {
                ...data.val(),
                id: data.key,
              }
              commit(setCommit, item)
              // commit('setLoading', false);

            }, function (error) {
              // console.log(error)
              dispatch('users/showErrorSessionExpired', null, {root:true})
              // commit('setLoading', false);
            })
          }
        }else{

          const dbRef = firebase.database().ref()
          let item
          // console.log(path + '/' + id)
          await dbRef.child(path + '/' + id).on('value', function (data) {
            // console.log(data.val(), id)
            item = {
              ...data.val(),
              id: data.key,
            }
            commit(setCommit, item)
            // commit('setLoading', false);
          }, function (error) {
            dispatch('users/showErrorSessionExpired', null, {root:true})
            // console.log(error)
            // commit('setLoading', false);
          })

        }

      } else {
        // console.log('no hay item')
        commit('SET_CURRENT_ITEM', null)
      }
    },
    deleteItem ({ commit, state, rootState, dispatch }, payload) {
      return new Promise((resolve, reject) => {
        let userId = ''
        if(rootState.users.user.adminUid){
          userId = rootState.users.user.adminUid
        }else{
          userId = rootState.users.user.uid
        }
        const id = payload.id
        commit('SET_LOADING', true)
        const promises = []
        // console.log(`inventory/pictures/${id}`)
        promises.push(firebase.database().ref().child(`users/${userId}/inventory/${id}`).remove())
        if (payload.pictures.imageInput1) {
          promises.push(firebase.storage().ref(`users/${userId}/inventory/pictures/${id}`).child('imageInput1').delete())
        }
        Promise.all(promises).then(function () {
          // commit('setWriting', false);
          resolve()
        }, function (error) {
          dispatch('users/showErrorSessionExpired', null, {root:true})
          commit('SET_LOADING', false)
          // console.log(error)
          reject()
        })
      })
    },
    async createItem ({ commit, state, rootState, dispatch }, payload) {
      commit('SET_LOADING', true)
      let userId = ''
      if(rootState.users.user.adminUid){
        userId = rootState.users.user.adminUid
      }else{
        userId = rootState.users.user.uid
      }
      // console.log(userId, payload)
      const key = payload.id ? payload.id : firebase.database().ref().child(`users/${userId}/inventory`).push().key
      if (payload.qrcode) {
        const qr = new QRious({
          element: document.getElementById('qrcode'),
          value: 'Tender',
        })
        qr.set({
          value: key,
          size: 300,
          padding: 25,
        })
        payload.qrcode = qr.toDataURL()
      }
      const itemData = {
        ...payload,
        id: key,
        created: firebase.database.ServerValue.TIMESTAMP,
      }
      // console.log(itemData)
      const updates = {}
      updates[`users/${userId}/inventory/${key}`] = itemData
      await firebase.database().ref().update(updates).then(function () {
        const log = {
          created: firebase.database.ServerValue.TIMESTAMP,
          title: `Se ha creado el producto ${payload.name}`,
          description: `Se ha creado con un precio de compra ${payload.price.buy} y precio de venta ${payload.price.sale}`,
          user: {
            email: rootState.users.user.email,
            name: rootState.users.profile.name,
          },
        }
        dispatch('transactions/sendLog', log, {root:true})
        // created!
        commit('SET_LOADING', false)
      }).catch(error => {
        dispatch('users/showErrorSessionExpired', null, {root:true})
        // console.log(error)
      })
      return itemData
    },
    async updateItem ({ commit, state, rootState, dispatch }, payload) {
      commit('SET_LOADING', true)
      // console.log(payload, 'updateee')
      let userId = ''
      if(rootState.users.user.adminUid){
        userId = rootState.users.user.adminUid
      }else{
        userId = rootState.users.user.uid
      }
      const itemData = payload.payload
      const messages = payload.message
      try {
        await firebase.database().ref(`users/${userId}/inventory/${itemData.id}`).update(itemData).then(function () {
          // updated!
          let description = ''
          messages.forEach((message, index) =>{
            if (index === messages.length-1) {
              description += ` ${message}.`
            } else {
              description += ` ${message},`
            }
          })
          // console.log(description)
          const log = {
            created: firebase.database.ServerValue.TIMESTAMP,
            title: `Se ha actualizado el producto ${itemData.name}`,
            description: `${description} Usuario que realizó el cambio: ${rootState.users.user.email}`,
            user: {
              email: rootState.users.user.email,
              name: rootState.users.profile.name,
            },
          }
          dispatch('transactions/sendLog', log, {root:true})
          commit('SET_LOADING', false)
        }).catch(function (err) {
          /* commit('SET_LOADING', false)
          dispatch('users/showErrorSessionExpired', null, {root:true}) */
          throw err
        })
      } catch (error) {
        commit('SET_LOADING', false)
      }
    },
  },
  getters: {
    getProductLog (state) {
      const productLog = []
      try {
        const log = state.transactions.filter((el) => {
          if (el.items) {
            for (let i = 0; i < el.items.length; i++) {
              if (el.items[i].name.includes(state.currentItem.name)) {
                return true
                break
              }
            }
          }
        })

        log.forEach(item => {
          item.items.forEach(el => {
            if (el.name.includes(state.currentItem.name)) {
              let utilityProd
              if (el.pricewithouttax) {
                utilityProd = (+el.pricewithouttax - +el.purchase) * 100 / +el.pricewithouttax
              } else {
                utilityProd = (+el.price - +el.purchase) * 100 / +el.price
              }
              productLog.push(
                {
                  reference_number: item.reference_number || 'n/a',
                  location_to: item.location_to,
                  location_from: item.location_from,
                  name: el.name,
                  time: item.time,
                  type: item.type,
                  amount: +el.amount,
                  qty: +el.qty || +el.qty === 0 ? el.qty: null,
                  purchase: +el.purchase,
                  price: +el.price,
                  total: +el.price * el.amount | 0,
                  utility: utilityProd,
                  bill: item,
                },
              )
            }
          })
        })
        if (state.shop) {
          const shop = state.shop
          const filteredTransactions = productLog.filter((transaction) => {
            if ((transaction.location_from && transaction.location_from.name === shop.name) || (transaction.location_to && transaction.location_to.name === shop.name)) {
              return true
            } else {
              return false
            }
          })
          return filteredTransactions
        } else {
          return productLog
        }
      } catch (err) {
        // console.log(err)
      }
    },
    getAllItems (state) {
      return state.product_list || []
    },
    getCurrentShopItems(state, getters, rootState) {
      const shop = rootState.shops.currentItem
      // const filtro = state.product_list.filter(item => !shop[item.id]);
      console.info(shop.id);
      return state.product_list.filter(product =>{
        try {
          if (product.location[shop.id]) {
            if (!shop.excluded[product.id]) {
              return true
            }
          }
        } catch (error) {
          console.info('error', error)
        }
      })
    },
    getItems (state, getters, rootState) {
      if (state.q === '' || !state.q) {
        const category = rootState.categories.currentItem
        const shop = rootState.shops.currentItem
        if (category.name) {
          switch (category.type) {
            case 'default':
              if (category.name === 'ALL') { return state.product_list }
              if (category.name === 'HOT') {
                if (!!shop && Object.keys(shop).length !== 0) {
                  if (state.product_list) {
                    const products = Array.prototype.slice.call(state.product_list).filter(
                      item => !!(item.location && item.location[shop.id])
                    )
                    return products
                  } else {
                    return []
                  }
                } else if ( state.product_list) {
                  return state.product_list.slice(0, 50)
                } else {
                  return []
                }
              }
              if (category.name === 'SOLDOUT') { 
                // DEBE TENERSE EN CUENTA EL TIPO BUNDLE. POR EL MOMENTO NO SE ESTA TENIENDO EN CUENTA POR EL  el/item.type !== 'bundle'
                if (!!shop && Object.keys(shop).length !== 0) {
                  if (state.product_list) {
                    return Array.prototype.slice.call(state.product_list)
                      .filter(item => !!(item.location && item.location[shop.id]) && item.type !== 'service' && item.type !== 'bundle' && item.location[shop.id].stock === 0)
                  } else {
                    return []
                  }
                } else {
                  let soldouts = []
                  Array.prototype.slice.call(state.product_list).forEach(el => {
                    if (el.type !== 'service' && el.type !== 'bundle' && el.location) {
                      let stock = 0
                      // console.log(el)
                      for (const key in el.location) {
                        if (el.location.hasOwnProperty(key)) {
                          const loc = el.location[key];
                          stock += +loc.stock
                        }
                      }
                      if (stock === 0){
                        soldouts.push(el)
                      }
                    }
                  })
                  return soldouts
                }
              }

              break
            default:
              try {
                const list = state.product_list.filter((el) => {
                  if (el.categories) {
                    for (let i = 0; i < el.categories.length; i++) {
                      if (el.categories[i].id === category.id) {
                        return true
                      }
                    }
                  }
                })
                return list
              } catch (err) {
                //
              }
              break
          }
        } else {
          return state.product_list || []
        }
      } else return state.product_list.filter(item => item.name.toUpperCase().includes(state.q.toUpperCase()))
    },
    getExportableInventory (state) {
      const list = []
      state.inventory.forEach(item => {
        list.push(
          {
            Categoria: item.category,
            Producto: item.name,
            'Cantidad en Punto': +item.location.store.stock,
            'Cantidad en Bodega': +item.location.warehouse.stock,
            'Precio Compra': +item.price.buy,
            'Precio Venta': +item.price.sale,
            'Total Vendidos': +item.sold | 0,
          },
        )
      })
      return list
    },
    getCurrentItem (state) {
      return state.currentItem
    },
    getCurrentType (state) {
      return state.currentType
    },
  },

}
